const env = {
  "apiUrl": "https://api.mothersheet.com"
}

export default env
